module.exports = {
	"id": "KW",
	"name": "Kuwait",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.005362,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.005362,
			"16": 0.008043,
			"17": null,
			"18": 0.002681,
			"19": 0.005362,
			"20": 0.008043,
			"21": 0.005362,
			"22": 0.005362,
			"23": 0.002681,
			"24": null,
			"25": null,
			"26": 0.013405,
			"27": 0.008043,
			"28": 0.013405,
			"29": 0.010724,
			"30": 0.021448,
			"31": 0.203756,
			"32": 0.013405,
			"33": 0.024129,
			"34": 0.021448,
			"35": 0.013405,
			"36": 0.013405,
			"37": 0.005362,
			"38": 0.016086,
			"39": 0.021448,
			"40": 0.008043,
			"41": 0.013405,
			"42": 0.042896,
			"43": 0.203756,
			"44": 0.029491,
			"45": 0.02681,
			"46": 0.02681,
			"47": 0.032172,
			"48": 0.024129,
			"49": 0.710465,
			"50": 0.050939,
			"51": 0.2681,
			"52": 0.195713,
			"53": 9.997449,
			"54": 2.731939,
			"55": 0.083111,
			"56": 0.02681,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.008043,
			"4": null,
			"5": null,
			"6": 0.010724,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.002681,
			"11": null,
			"12": 0.010724,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.002681,
			"17": 0.002681,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.002681,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.005362,
			"28": 0.002681,
			"29": 0.002681,
			"30": 0.002681,
			"31": null,
			"32": 0.002681,
			"33": 0.008043,
			"34": 0.005362,
			"35": 0.005362,
			"36": 0.005362,
			"37": 0.005362,
			"38": 0.010724,
			"39": 0.010724,
			"40": 0.008043,
			"41": 0.010724,
			"42": 0.010724,
			"43": 0.050939,
			"44": 0.072387,
			"45": 0.064344,
			"46": 0.056301,
			"47": 0.198394,
			"48": 0.308315,
			"49": 1.750693,
			"50": 0.101878,
			"51": 0.002681,
			"52": null,
			"3.5": 0.005362,
			"3.6": 0.024129
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005362,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005362,
			"35": null,
			"36": 0.021448,
			"37": 0.072387,
			"38": 0.018767,
			"39": 0.013405,
			"40": 0.243971,
			"41": 0.02681,
			"42": 0.005362,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.010724
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.024129,
			"6": 0.021448,
			"7": 0.034853,
			"8": 0.158179,
			"9": 0.152817,
			"10": 0.844515,
			"3.1": null,
			"3.2": null,
			"5.1": 0.083111,
			"6.1": 0.018767,
			"7.1": 0.005362,
			"9.1": 0.565691
		},
		"ios_saf": {
			"8": 0,
			"10": 9.81636955704,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.264539800791,
			"8.1-8.4": 0.488726072648,
			"9.0-9.2": 0.233153722731,
			"9.3": 3.55708884679
		},
		"android": {
			"3": 0,
			"4": 0.0483205297158,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00604006621447,
			"4.1": 0.174299053618,
			"4.2-4.3": 0.435747634044,
			"4.4": 0.999199525194,
			"4.4.3-4.4.4": 1.00782819121
		},
		"ie": {
			"6": 0.00808016237624,
			"7": 0.010773549835,
			"8": 0.393234568977,
			"9": 0.646412990099,
			"10": 0.263951970957,
			"11": 2.74725520792,
			"5.5": null
		},
		"op_mob": {
			"0": 0.34675473152,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00963207587557
		},
		"edge": {
			"12": 0.077749,
			"13": 0.319039,
			"14": 0.538881
		},
		"ie_mob": {
			"10": 0.0404091267606,
			"11": 0.164522873239
		},
		"bb": {
			"7": 0.007319,
			"10": null
		},
		"samsung": {
			"0": 5.167214
		},
		"and_uc": {
			"0": 22.227803
		},
		"op_mini": {
			"0": 4.6717661926
		},
		"and_chr": {
			"0": 22.940905
		},
		"and_ff": {
			"0": 0.021957
		}
	},
	"total": 97.6593624502
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KW.json
 ** module id = 568
 ** module chunks = 0
 **/